module.exports = __webpack_public_path__ + "static/media/menu_customers.874be6b0.png";